import { campaignAction } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useCampaignAction = () => {
    const entityUpdater = useEntityQueryUpdate();

    const successMessages = {
        Enqueue: 'Successfully enqueued campaign',
        Schedule: 'Successfully scheduled campaign',
        Pause: 'Successfully paused campaign',
        Stop: 'Successfully stopped campaign',
    };

    const mutation = useMutation({
        mutationKey: 'campaign_action',
        mutationFn: ({ id, model }) => campaignAction({ id, model }),
        onSuccess: (data, variables, ctx) => {
            entityUpdater([['campaigns'], ['campaign', data.id]], data);
            notifications.show({
                title: 'Success',
                message: successMessages[variables.model.action] || 'Success',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useCampaignAction;
